const palette = {
  text: {
    primary: "#121312",
    secondary: "#A1A3A7",
    disabled: "#DDDEE0",
  },
  safeGreen: {
    dark: "#1E2A23",
    main: "#12ff80",
    light: "#EFFFF4",
  },
  primary: {
    dark: "#3c3c3c",
    main: "#121312",
    light: "#636669",
  },
  background: {
    default: "#F6F7F8",
    paper: "#FFFFFF",
    main: "#F4F4F4",
  },
  secondary: {
    main: "#B2BBC0",
    light: "#B0FFC9",
  },
  border: {
    main: "#A1A3A7",
    light: "#DCDEE0",
    background: "#F4F4F4",
  },
}

export default palette
